<template>
  <el-card class="ibox">
    <div slot="header" class="clearfix flex justify-between">
      <el-input v-model="goodCashierCategoryInfo.prodNameLike" placeholder="请输入商品名称" style="width: 300px;"
        @keyup.enter.native="_loadCategoryProductDetils()"></el-input>
    </div>
    <div class="">
      <el-table :data="goodCashierCategoryInfo.productCategorys" style="width: 100%; margin-bottom: 20px;" border>
        <el-table-column v-for="productCategory in goodCashierCategoryInfo.productCategorys"
          :key="productCategory.categoryId" :label="productCategory.categoryName" align="center"
          :class-name="goodCashierCategoryInfo.curCatelogId == productCategory.categoryId ? 'active-category' : ''">
          <template slot-scope="scope">
            <div @click="_payCategoryProductDetils(scope.row)" style="cursor: pointer;">
              {{ scope.row.categoryName }}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-row :gutter="20">
        <el-col :span="6" v-for="productDetail in goodCashierCategoryInfo.productDetails" :key="productDetail.productId"
          style="margin-bottom: 20px;">
          <el-card shadow="hover" @click.native="_loadAddProduct(productDetail)"
            style="cursor: pointer; text-align: center;">
            <img :src="productDetail.coverPhoto" style="width: 80px; height: 80px; border-radius: 5px;">
            <div style="margin-top: 10px; font-size: 12px;">{{ productDetail.prodName }}</div>
            <div style="font-size: 12px;">{{ _getSpecValue(productDetail) }}</div>
            <div style="color: red; font-size: 12px;">
              {{ productDetail.cateType == "3" ? "积分" : "￥" }}{{ productDetail.defaultSpecValue.price }}
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryProductCategory, queryCashierProductDetail } from '@/api/goods/goodCashierCategoryApi'

export default {
  name: 'GoodCashierCategory',
  data() {
    return {
      goodCashierCategoryInfo: {
        productCategorys: [],
        productDetails: [],
        curCatelogId: '',
        prodNameLike: ''
      }
    }
  },
  methods: {
    _queryProductCategorys() {
      const params = {
        page: 1,
        row: 50,
        cateTypes: '2,3',
        shopId: getShopId()
      }

      queryProductCategory(params).then(res => {
        this.goodCashierCategoryInfo.productCategorys = res.data
        if (res.data.length > 0) {
          this._payCategoryProductDetils(res.data[0])
        }
      }).catch(err => {
        console.error('获取商品分类失败:', err)
      })
    },
    _payCategoryProductDetils(productCategory) {
      this.goodCashierCategoryInfo.curCatelogId = productCategory.categoryId
      const params = {
        page: 1,
        row: 50,
        shopId: getShopId(),
        categoryId: productCategory.categoryId,
      }

      queryCashierProductDetail(params).then(res => {
        this.goodCashierCategoryInfo.productDetails = res.data
      }).catch(err => {
        console.error('获取商品详情失败:', err)
      })
    },
    _loadAddProduct(productDetail) {
      this.$emit('chooseProduct', productDetail)
    },
    _getSpecValue(productDetail) {
      let specValue = ''
      productDetail.defaultSpecValue.productSpecDetails.forEach(detail => {
        specValue += (detail.detailValue + "/")
      })
      if (specValue.endsWith("/")) {
        specValue = specValue.substring(0, specValue.length - 1)
      }
      return specValue
    },
    _loadCategoryProductDetils() {
      console.log('_loadCategoryProductDetils')
    }
  },
  created() {
    this._queryProductCategorys()
  }
}
</script>

<style scoped>
.ibox-content {
  min-height: 600px;
}

.active-category {
  background-color: #f5f7fa;
}
</style>